import { render, staticRenderFns } from "./mMenuPanel.vue?vue&type=template&id=3b36c716"
import script from "./mMenuPanel.vue?vue&type=script&lang=js"
export * from "./mMenuPanel.vue?vue&type=script&lang=js"
import style0 from "./mMenuPanel.vue?vue&type=style&index=0&id=3b36c716&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports